module.exports = __webpack_public_path__ + "static/media/close.25ed8c2e.svg";